<template>
	<div id="player-footer">
		<label id="poem">{{ poem }}</label>

		<Banner
			v-if="isNotBannerEmpty"
			:bannerPath="banner['image-path']"
			:linkURL="banner['link']"
		/>
		
		<!-- リンク付き画像 -->
		<EventLink
			v-if="event"
			id="event-link"
			:name="event['name']"
			:link="event['link']"
			:bannerPath="event['banner']"
		>
		</EventLink>

		

		<table id="footer-table">
			<tr id="comment-row">
				<th>
					<label id="comment-header">コメント</label>
				</th>
				<td>
					<div id="comment-area">
						<p v-for="(comment, index) in comments" :key="index">{{ comment }}</p>
					</div>
				</td>
			</tr>
			<tr id="bpm-row" v-if="bpm">
				<th>
					<label>BPM</label>
				</th>
				<td>
					<label>{{ bpm }}</label>
				</td>
			</tr>
			<tr id="original-source-row" v-if="originalSource">
				<th>
					<label>原曲</label>
				</th>
				<td>
					<label>{{ originalSource }}</label>
				</td>
			</tr>
		</table>

		<div id="back-link">
			<router-link to="/danoni">ダンおに置き場に戻る</router-link>
		</div>
	</div>
</template>

<script>
import EventLink from "./EventLink.vue";
import Banner from "../Banner.vue";

export default {
	components: {
		EventLink: EventLink,
		Banner: Banner,
	},
	props: {
		poem: {
			type: String,
		},
		comments: {
			type: Array,
		},
		bpm: {
			type: Number,
		},
		originalSource: {
			type: String,
		},
		banner: {
			type: Object,
		},
		event: {
			type: Object,
		},
		artistBannerPath: {
			type: String,
		}
	},
	computed: {
		commentsLength() {
			return this.comments.length;
		},
		isNotBannerEmpty() {
			return this.banner != null;
		}
	}
}
</script>

<style scoped>
	#player-footer {
		padding: 16px;
		text-align: center;
	}
	#back-link {
		margin-top: 2rem;
	}
	#poem {
		display: inline-block;
		margin-bottom: 16px;
	}
	#event-link {
		margin: 16px 0;
	}

	#footer-table,
	#footer-table th,
	#footer-table td{
		border-collapse: collapse;
		border: 1px #757575 solid;
	}
	#footer-table {
		margin: auto;
		margin-top: 16px;
	}
	#footer-table td {
		text-align: left;
	}

	#footer-table td > * {
		margin: 16px;
	}
</style>